module.exports = __webpack_public_path__ + "img/ground-sea-cool.8b582688.png";